<template>
  <div>
    <h3 class="c-orange pb-15 fs-24">2. Mude sua senha (opcional)</h3>
    <b-row>
      <b-col cols="12" sm="12" md="12" lg="12" xl="12" class="mb-3">
        <InputPassword
          :value.sync="password"
          :errorMessage="ErrorMessages.password"
          @input.native="ErrorMessages.password = ''"
        />
      </b-col>
      <b-col cols="12" sm="12" md="12" lg="12" xl="12">
        <InputPassword
          label="Confirme sua senha"
          placeholder="Digite novamente a sua senha"
          :value.sync="confirmPassword"
          :errorMessage="ErrorMessages.confirmPassword"
          @input.native="ErrorMessages.confirmPassword = ''"
        />
      </b-col>
    </b-row>
  </div>
</template>
<script>
import InputPassword from '../../../components/Inputs/InputPassword.vue';

export default {
  name: 'ShopkeeperChangePassword',
  components: {
    InputPassword,
  },
  data() {
    return {
      password: '',
      confirmPassword: '',
      ErrorMessages: {
        password: '',
        confirmPassword: '',
      },
    };
  },
  methods: {
    validate() {
      let isValid = true;

      if (!this.password && !this.confirmPassword) {
        return isValid;
      }

      if (!this.password) {
        isValid = false;
        this.ErrorMessages.password = 'Senha inválida';
      }

      if (!this.confirmPassword) {
        isValid = false;
        this.ErrorMessages.confirmPassword =
          'As senha de confirmação é inválida';
      }

      if (this.confirmPassword !== this.password) {
        isValid = false;
        this.ErrorMessages.confirmPassword = 'As senhas precisam ser iguais';
      }

      return isValid;
    },
  },
};
</script>
